import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useAction } from "../components/ui";
import { api, type PublicNotice as Data } from "../lib/api";
import { noticeSections } from "../lib/notice";
import { useTitle } from "../lib/title";

/** An agency's privacy notice for candidates: public, linked from the recruiter's first email. */
export function PublicNotice() {
  const { tenantId = "" } = useParams();
  const [data, setData] = useState<Data | null>(null);
  const load = useAction();
  useTitle(data ? `Privacy notice: ${data.agency}` : "Privacy notice");

  useEffect(() => {
    void load.run(async () => setData(await api.publicNotice(tenantId)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  if (!data) {
    return (
      <main className="page legal">
        <h1 className="display">Privacy notice</h1>
        {load.error ? <p className="lede">{load.error}</p> : <p className="label">Loading…</p>}
      </main>
    );
  }

  return (
    <main className="page legal">
      <p className="label">{data.agency}</p>
      <h1 className="display">How we use your details</h1>
      <p className="lede">For people we've contacted about jobs, or who've sent us their CV.</p>
      <ol className="legal-sections">
        {noticeSections(data).map((s, i) => (
          <li key={s.heading}>
            <h2>
              <span className="figures">{String(i + 1).padStart(2, "0")}</span> {s.heading}
            </h2>
            {s.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
            {s.list && (
              <ul>
                {s.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ol>
    </main>
  );
}
